var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCardHourglass = function SvgCreditCardHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3A1.5 1.5 0 0 0 0 4.5v1a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-1A1.5 1.5 0 0 0 18.5 3h-17zM.5 8a.5.5 0 0 0-.5.5v7A1.5 1.5 0 0 0 1.5 17h11.817c.088-.175.193-.342.314-.499l.391-.501-.39-.501A3 3 0 0 1 13 13.657V12.25A2.25 2.25 0 0 1 15.25 10h4.389c.123 0 .243.01.361.029V8.5a.5.5 0 0 0-.5-.5H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.657V13c0-.036.002-.073.006-.108l-.001-.002-.002-.001-.003-.003v-.636a.25.25 0 0 1 .25-.25h4.389a.25.25 0 0 1 .25.25v.636l-.003.003-.003.003a.95.95 0 0 1 .006.108v.657a1 1 0 0 1-.211.614l-.867 1.115a1 1 0 0 0 0 1.228l.867 1.115a.997.997 0 0 1 .211.614v1.407a.25.25 0 0 1-.25.25H15.25a.25.25 0 0 1-.25-.25v-1.407a1 1 0 0 1 .211-.614l.867-1.115a1 1 0 0 0 0-1.228l-.867-1.115a1 1 0 0 1-.211-.614zm3.494-.768H16.39a.5.5 0 0 0-.379.826l1.052 1.223a.5.5 0 0 0 .758 0l1.052-1.223a.5.5 0 0 0-.379-.826z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCreditCardHourglass;